import * as localForage from 'localforage';

export const getToken = async (): Promise<string | null> => {
	return await localForage.getItem('token');
};
